/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_Delete_TitleInputs */

const en_settings_apikeys_delete_title = /** @type {(inputs: Settings_Apikeys_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete API key?`)
};

const zh_settings_apikeys_delete_title = /** @type {(inputs: Settings_Apikeys_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除 API 密钥？`)
};

/**
* | output |
* | --- |
* | "Delete API key?" |
*
* @param {Settings_Apikeys_Delete_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_delete_title = /** @type {((inputs?: Settings_Apikeys_Delete_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_Delete_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_apikeys_delete_title(inputs)
	return zh_settings_apikeys_delete_title(inputs)
});
export { settings_apikeys_delete_title as "settings.apikeys.delete_title" }